import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpParams,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { AccountService } from '../service/accountservice';
import Swal from 'sweetalert2';

import { catchError, finalize, map } from 'rxjs/operators';
import { LoadingService } from '../service/LoadingService';
import { AppState } from '../store/buid.reducer';
import { select, Store } from '@ngrx/store';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  BUID: string;
  isApiUrl: boolean;
  constructor(
    private accountService: AccountService,
    private loadingService: LoadingService,
    private store: Store<AppState>,
  ) {
    this.store
      .pipe(select((state) => state.buidState.BUID))
      .subscribe((buid) => {
        this.BUID = buid;
      });
  }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    // add auth header with jwt if user is logged in and request is to the api url
    //const user = this.accountService.userValue;
    //const isLoggedIn = user && user.password;
    this.isApiUrl = request.url.includes('api');
    if (this.isApiUrl) {
      this.loadingService.setLoading(true, request.url);
    }

    let tokenInfo = JSON.parse(localStorage.getItem('login') as string);
    //     if(tokenInfo!=null)
    //    else
    let CUID = '',
      BUID = 0;
    try {
      if (localStorage.hasOwnProperty('CUID'))
        CUID = localStorage.getItem('CUID');
      if (CUID == null) CUID = '';

      if (localStorage.hasOwnProperty('BUID'))
        BUID = Number(this.BUID ? this.BUID : 0);
      if (BUID == null) BUID = 0;
    } catch (exception) {
      console.error('Some error occured in log in.');
      Swal.close();
      Swal.fire('Error!', 'Some error occured !', 'warning');
    }
    //let BUID = JSON.parse(localStorage.getItem('BUID') as string);

    const isApiUrl = request.url.startsWith(environment.appUrl);
const isAuthUrl = request.url.includes('api/Authentication');
    let contentType = '';
    if (request.headers.has('Content-Type'))
      contentType = request.headers.get('Content-Type');
    else contentType = 'application/json; charset=utf-8';

    if (tokenInfo && tokenInfo.token && !isAuthUrl) {
      request = request.clone({
        
        setHeaders: {
          'Content-Type': contentType,
          Accept: '*/*',
          Authorization: `Bearer ${tokenInfo.token}`,
          CUID: CUID,
          BUID: Number(this.BUID ? this.BUID : 0) + '',
        },
      });
    } else {
      request = request.clone({
        withCredentials: true,
        setHeaders: {
          'Content-Type': contentType,
          Accept: '*/*',
        },
      });
    }
    // request.headers.append('BUID',1111+"");
    return next.handle(request).pipe(
      finalize(() => {
        if (isApiUrl) {
          this.loadingService.setLoading(false, request.url);
        }
      }),
    );
  }
}
